import prodFbConfig from './firebase/prod.json'
import stagingFbConfig from './firebase/staging.json'
import testFbConfig from './firebase/test.json'

export const projectName = () => {
  const raw = window.location.hostname.split('.')[0]

  if (raw === 'minigolflive') {
    return 'wagm-prod'
  }

  if (raw === 'localhost') {
    return 'wagm-test'
  }

  return raw
}

// change this function in order to test the functions locally
export const functionUrl = functionName => {
  // const raw = window.location.hostname.split('.')[0]
  // const host = raw === 'localhost' ? 'http://localhost:5000/wagm-test/us-central1' :
  const host = `https://us-central1-${projectName()}.cloudfunctions.net`

  return `${host}/${functionName}`
}

const resolveFirebaseConfig = () => {
  const name = projectName()

  if (name === 'wagm-prod') {
    return prodFbConfig
  }

  if (name === 'wagm-staging') {
    return stagingFbConfig
  }

  return testFbConfig
}

export const firebaseConfig = resolveFirebaseConfig()



// WEBPACK FOOTER //
// ./src/config/index.ts